module.exports = __webpack_public_path__ + "img/6.751ba1e5.png";